import {FORMAT_QUERY_KEY} from 'common/src/modules/creativeTemplates/creativeTemplates.consts';

export function getActiveFormat(): string {
  const urlParams = new URLSearchParams(window.location.search);

  return urlParams.get(FORMAT_QUERY_KEY) ?? '';
}
